const SET_VIEW = 'SET_VIEW';
const SET_SEARCHTYPE = 'SET_SEARCHTYPE';
const SET_STATSNAME = 'SET_STATSNAME';
const SET_FILTERS = 'SET_FILTERS';
const SET_TILE_PAGINATION = 'SET_TILE_PAGINATION';
const SET_GRID_PAGINATION = 'SET_GRID_PAGINATION';
const SET_LIST_PAGINATION = 'SET_LISTPAGESKIP';
const SET_LOADMAPVIEW = 'SET_LOADMAPVIEW';
const SET_LOADPFCHARTVIEW = 'SET_LOADPFCHARTVIEW';
const SET_APPLYCLICK = 'SET_APPLYCLICK';

const SET_MAPMETADATA = 'SET_MAPMETADATA';
export {
    SET_VIEW,
    SET_SEARCHTYPE,
    SET_STATSNAME,
    SET_FILTERS,
    SET_TILE_PAGINATION,
    SET_GRID_PAGINATION,
    SET_LIST_PAGINATION,
    SET_LOADMAPVIEW,
    SET_MAPMETADATA,
    SET_LOADPFCHARTVIEW,
    SET_APPLYCLICK
};